import { Share2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, shareLink } from "@/lib/api";

// Shares a link whose preview (WhatsApp, iMessage…) shows the headline, summary and a preview image.
export const shareItem = async (kind, id) => {
  const { data } = await api.post("/share", { kind, item_id: id, channel: "link" });
  const r = await shareLink(`/api/public/og/${kind}/${id}?ref=${data.ref}`);
  if (r === "copied") toast.success("Link copied. Paste it into WhatsApp or anywhere: it shows a preview, no account needed");
};

export const ShareChip = ({ kind, id, testid }) => (
  <button type="button" data-testid={testid} onClick={(e) => { e.preventDefault(); e.stopPropagation(); shareItem(kind, id); }}
    className="inline-flex items-center gap-1 rounded-full border border-border bg-white px-2.5 py-1 text-xs font-medium text-slate-700 transition-colors hover:border-slate-400">
    <Share2 size={12} />Share
  </button>
);

const SIDE = { left: "L", "centre-left": "L", "centre-right": "R", right: "R" };
const bothSidesBack = (f) => {
  const sides = new Set([f.original, ...(f.corroborating || [])].map((r) => SIDE[r?.leaning]).filter(Boolean));
  return new Set((f.corroborating || []).map((r) => r.source_id)).size >= 2 && sides.has("L") && sides.has("R");
};

export const DisputingNote = ({ f, compact }) => {
  const n = new Set((f.conflicting || []).map((r) => r.source_id)).size;
  if (!n || f.status === "DISPUTED") return null;
  return compact
    ? <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800" data-testid={`fact-disputing-badge-${f.id}`}><AlertTriangle size={11} />{n} disputing source{n > 1 ? "s" : ""}</span>
    : (
      <a href="#fact-conflicting" className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 hover:bg-amber-100" data-testid="fact-disputing-note">
        <AlertTriangle size={16} className="mt-0.5 shrink-0" />
        <span>Disputing sources located: {n} approved source{n > 1 ? "s" : ""} reported something different. Published because {bothSidesBack(f) ? "several sources, including from both sides, back it up" : "the disagreement isn't a left-versus-right split"}. See them below.</span>
      </a>
    );
};
